import { Routes, Route, Navigate, BrowserRouter, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Security } from "@okta/okta-react";
import Login from './components/Login';
// import LoginCallback from './components/LoginCallback';
import Dashboard from './components/Dashboard';
import EmployeeList from './components/EmployeeList';
import EmployeeDetail from './components/EmployeeDetail';
import CSVUpload from './components/CSVUpload';
import Statistics from './components/Statistics';
import Layout from './components/Layout';
import './index.css';
import oktaAuth from "./oktaConfig";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, userRole, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  // Restrict access if the user is successfully authenticated but does not have a role

  if (
    isAuthenticated &&
    (
      userRole === null ||
      userRole === undefined
    )
  ) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-center">Sorry, access to the HR Query App is restricted on your account.</p>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function AppWithRouter() {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth) => {
    navigate("/");
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* <Route path="/login/callback" element={<LoginCallback />} /> */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employees"
            element={
              <ProtectedRoute>
                <Layout>
                  <EmployeeList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employees/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <EmployeeDetail />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <Layout>
                  <CSVUpload />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics"
            element={
              <ProtectedRoute>
                <Layout>
                  <Statistics />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/login/callback"
            element={
              <LoginCallback />
            }
          /> */}
        </Routes>
      </AuthProvider>
    </Security>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppWithRouter />
    </BrowserRouter>
  );
};